import { initialStep, getStage, getNextStep, StepId } from "./Steps";
import { Stage } from "./Stages";

export const enumerateStages = (): Stage[] => {
    let currentStep: StepId | null = initialStep;

    const stages: Stage[] = []

    while (currentStep !== null) {
        const currentStage = getStage(currentStep);
        if (currentStage !== null && !stages.includes(currentStage)) {
            stages.push(currentStage);
        }

        currentStep = getNextStep(currentStep);
    }

    return stages;
}
